export enum CheckType {
    /**
     * @description Checkbox type
     */
    Checkbox = 'checkbox',

    /**
     * @description Radio type
     */
    Radio = 'radio'
}

/**
 * @description Check type
 * @example
 * const checkType: ICheckType = 'checkbox' | 'radio' | CheckType.Checkbox | CheckType.Radio
 */
export type ICheckType = CheckType | 'checkbox' | 'radio'
